<script>
  import { DropShadow } from '../_shared'
  import AppStoreGridRowItem from './AppStoreGridRowItem'

  export default {
    name: 'app-store-grid-row',

    components: {
      AppStoreGridRowItem,
      DropShadow
    },

    props: {
      heading: {
        type: String,
        required: true
      },
      apps: {
        type: Array,
        required: true
      }
    }
  }
</script>

<template>
  <div class="grid-row">
    <h5>{{ heading }}</h5>
    <b-container fluid>
      <b-row>
        <app-store-grid-row-item v-for="(app, index) in apps" :key="index" :app="app"/>
      </b-row>
    </b-container>
    <drop-shadow/>
  </div>
</template>

<style src="./AppStoreGridRow.scss" lang="scss" scoped></style>
